/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Add_Player_Vekn_Id_LabelInputs */



/**
* | output |
* | --- |
* | "VEKN ID" |
*
* @param {Add_Player_Vekn_Id_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const add_player_vekn_id_label = /** @type {((inputs?: Add_Player_Vekn_Id_LabelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Add_Player_Vekn_Id_LabelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("VEKN ID")
	if (locale === "es") return /** @type {LocalizedString} */ ("ID VEKN")
	if (locale === "pt") return /** @type {LocalizedString} */ ("VEKN ID")
	if (locale === "it") return /** @type {LocalizedString} */ ("VEKN ID")
	return /** @type {LocalizedString} */ ("VEKN ID")
});